<div class="lookup-list-shell">
    <div class="lookup-list-panel">
        <div class="lookup-list-header">
            <div class="field-heading">
                <!-- <span class="eyebrow" setColor="primaryColour" appLocalizationPopupDirective localizationCode="LookupList-LookupValues">{{'Lookup values' | translate: {Default: 'Lookup values'} }}</span> -->
                <span class="eyebrow" setColor="primaryColour">{{ tableListField?.parentTable?.name }}</span>
                <h2>{{tableListField.name}}</h2>
            </div>
            <div class="buttons-container">
                <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="showAddMultiple = true; showAddSingle = false" aria-label="Add multiple lookup values" appLocalizationPopupDirective localizationCode="LookupList-AddMultiple">
                    <mat-icon class="material-icons-outlined">add</mat-icon> {{'Add Multiple' | translate: {Default: 'Add Multiple'} }}
                </button>
                <button mat-flat-button appPreventDoubleClick (throttledClick)="showAddSingle = true; showAddMultiple = false" aria-label="Add a lookup value" appLocalizationPopupDirective localizationCode="LookupList-Add">
                    <mat-icon class="material-icons-outlined">add</mat-icon> {{'Add' | translate: {Default: 'Add'} }}
                </button>
            </div>
        </div>
        <div class="lookup-list-body">

            <ng-template *ngIf="isLoading; else loaded">
                <ngx-skeleton-loader count="10" [theme]="{ 'height.px': 30 }"></ngx-skeleton-loader>
            </ng-template>

            <ng-template #loaded>
                <div *ngIf="tableListFieldOptions.listOptions.length > 0 || tableListFieldOptions.prioritized.length > 0; else noContent" class="lookup-values-container">
                    <div class="select-all-container">
                        <span appLocalizationPopupDirective localizationCode="LookupList-SelectAll">{{'Select all values' | translate: {Default: 'Select all values'} }}</span>
                        <mat-checkbox setColor="primaryColour" class="example-margin" (change)="toggleSelectAll($event)" [checked]="selectAll"></mat-checkbox>
                    </div>

                    <mat-selection-list #selectionList disableRipple="true" [(ngModel)]="selectedTableListFieldOptions">
                        <!-- Prioritized Items -->
                        <div *ngIf="tableListFieldOptions.prioritized.length > 0">
                            <div class="section-label" mat-subheader appLocalizationPopupDirective localizationCode="LookupList-Prioritized">{{'Prioritized' | translate: {Default: 'Prioritized'} }}</div>
                            <mat-list-option setColor="primaryColour" *ngFor="let option of tableListFieldOptions.prioritized" [value]="option">
                                <div class="list-item-content">
                                    <div class="text">
                                        {{option.text}} <span class="dates">{{option.startDate | date:medium}} - {{option.endDate | date:medium}}</span>
                                    </div>
                                    <div class="lookup-buttons">
                                        <mat-icon 
                                            setColor
                                            [setColorRules]="[
                                                {
                                                    color: 'primaryColour',
                                                    events: ['hover']
                                                }
                                            ]"
                                            class="material-icons-outlined" 
                                            matTooltip="Copy to another group" 
                                            appPreventDoubleClick 
                                            (throttledClick)="openCopyDialog($event, option.id)"
                                        >
                                            content_copy
                                        </mat-icon>
                                        <mat-icon 
                                            setColor
                                            [setColorRules]="[
                                                {
                                                    color: 'primaryColour',
                                                    events: ['hover']
                                                }
                                            ]"
                                            class="material-icons-outlined" 
                                            matTooltip="Edit" 
                                            appPreventDoubleClick 
                                            (throttledClick)="getLookupData($event, option.id)"
                                        >
                                            edit
                                        </mat-icon>
                                        <mat-icon 
                                            setColor
                                            [setColorRules]="[
                                                {
                                                    color: 'primaryColour',
                                                    events: ['hover']
                                                }
                                            ]"
                                            class="material-icons-outlined" 
                                            matTooltip="Delete" 
                                            appPreventDoubleClick 
                                            (throttledClick)="openConfirmDeleteDialog($event, option)"
                                        >
                                            delete
                                        </mat-icon>
                                    </div>
                                </div>
                            </mat-list-option>

                            <mat-divider></mat-divider>
                        </div>

                        <!-- Non prioritized items -->
                        <mat-list-option setColor="primaryColour" *ngFor="let option of tableListFieldOptions.listOptions" [value]="option">
                            <div class="list-item-content">
                                <div class="text">
                                    {{option.text}} <span class="dates">{{option.startDate | date:medium}} - {{option.endDate | date:medium}}</span>
                                </div>
                                <div class="lookup-buttons">
                                    <mat-icon 
                                        setColor
                                        [setColorRules]="[
                                            {
                                                color: 'primaryColour',
                                                events: ['hover']
                                            }
                                        ]"
                                        class="material-icons-outlined" 
                                        matTooltip="Copy to another group" 
                                        appPreventDoubleClick 
                                        (throttledClick)="openCopyDialog($event, option.id)"
                                    >
                                        content_copy
                                    </mat-icon>
                                    <mat-icon 
                                        setColor
                                        [setColorRules]="[
                                            {
                                                color: 'primaryColour',
                                                events: ['hover']
                                            }
                                        ]"
                                        class="material-icons-outlined" 
                                        matTooltip="Edit" 
                                        appPreventDoubleClick 
                                        (throttledClick)="openEditLookupDialog($event, option.id)"
                                    >
                                        edit
                                    </mat-icon>
                                    <mat-icon 
                                        setColor
                                        [setColorRules]="[
                                            {
                                                color: 'primaryColour',
                                                events: ['hover']
                                            }
                                        ]"
                                        class="material-icons-outlined" 
                                        matTooltip="Delete" 
                                        appPreventDoubleClick 
                                        (throttledClick)="openConfirmDeleteDialog($event, option)"
                                    >
                                        delete
                                    </mat-icon>
                                </div>
                            </div>
                        </mat-list-option>
                    </mat-selection-list>

                    <div class="bottom-controls" *ngIf="selectedTableListFieldOptions.length > 0">
                        <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="openConfirmDeleteAllDialog()">
                            <mat-icon class="material-icons-outlined">delete</mat-icon> {{'Delete all selected' | translate: {Default: 'Delete all selected'} }}
                        </button>
                        <button mat-flat-button appPreventDoubleClick (throttledClick)="openCopyDialog($event)" appLocalizationPopupDirective localizationCode="LookupList-CopyAllSelected">
                            <mat-icon class="material-icons-outlined">content_copy</mat-icon> {{'Copy all selected' | translate: {Default: 'Copy all selected'} }}
                        </button>
                    </div>
                </div>

                <ng-template #noContent>
                    <div class="lookup-values-container">
                        <div class="no-content-container">
                            <h3>No list option values yet</h3>
                            <div class="text">Add some values</div>
                            <div class="buttons-container">
                                <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="showAddMultiple = true; showAddSingle = false" appLocalizationPopupDirective localizationCode="LookupList-AddMultiple">
                                    <mat-icon class="material-icons-outlined">add</mat-icon> {{'Add Multiple' | translate: {Default: 'Add Multiple'} }}
                                </button>
                                <button mat-flat-button appPreventDoubleClick (throttledClick)="showAddSingle = true; showAddMultiple = false" appLocalizationPopupDirective localizationCode="LookupList-Add">
                                    <mat-icon class="material-icons-outlined">add</mat-icon> {{'Add' | translate: {Default: 'Add'} }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </div>
    <div class="lookup-form-panel" *ngIf="showAddMultiple || showAddSingle">
        <app-add-multiple-values
            *ngIf="showAddMultiple"
            [listGroup]="tableListField.ListGroup"
            (saveComplete)="saveComplete($event)"
            (close)="closeAddValue()"
        >
        </app-add-multiple-values>

        <app-add-single-value
            *ngIf="showAddSingle"
            [listGroup]="tableListField.ListGroup"
            (saveComplete)="saveComplete($event)"
            (close)="closeAddValue()"
        ></app-add-single-value>
    </div>
</div>

